/**
 * Config de la vista "Pruebas del hub": prueba los endpoints que el servicio expone al factor
 * (LIQUITECH) TAL COMO los consume él, a través del hub externo.
 *
 * La X-API-Key del consumidor NO vive en el código ni en el bundle: la inyecta quien hace de
 * proxy de `/hub-api/*` (el hub no expone CORS, así que el navegador pega same-origin):
 *  - local: `ng serve` con `src/proxy.conf.js`, que lee la key de la variable HUB_API_KEY
 *    (`HUB_API_KEY=isi_… npm start`).
 *  - cluster: nginx (ver `nginx.conf`), con HUB_API_KEY tomada de un Secret. Sin esa variable el
 *    proxy queda apagado y la vista responde 404.
 */
export const HUB_TEST_CONFIG = {
  /** La vista solo existe fuera de producción: el build `production` la reemplaza por hub-test.config.prod.ts. */
  habilitado: true,
  /** Base pública del producto en el hub: {hub}/v1/<slug>, vía el proxy /hub-api. */
  baseUrl: '/hub-api/v1/factoring',
  /** Host real al que apunta el proxy (solo para mostrarlo en la UI). */
  hubHost: 'https://dev.hub.tiendasisimo.com',
};
